/**
 * File messageBox.js
 * Description: File dùng trung gian để gọi thông báo
 * creatd by: nntam - 16/8/2019
 */
import { createApp, h } from "vue";
import MsMessageBox from "@/components/msmessagebox/MsMessageBox.vue";
import { registerComponents } from "@/commons/globalComponents";

class MessageBox {
  show(option) {
    var promise = new Promise((resolve, reject) => {
      let me = this;
      // cấu hình button mặt định
      var btnConfigDefault = [
        {
          key: "Cancel",
          hasBtn: false,
          target: "Left",
          text: "Hủy bỏ",
          typeButton: "third",
        },
        {
          key: "Close",
          hasBtn: false,
          target: "Center",
          text: "Đóng",
          typeButton: "primary",
        },
        {
          key: "Yes",
          hasBtn: false,
          target: "Right",
          text: "Có",
          typeButton: "primary",
          focus: true,
        },
        {
          key: "No",
          hasBtn: false,
          target: "Right",
          text: "Không",
          typeButton: "secondary",
        },
      ];

      // merge cấu hình người dùng với cấu hình mặc định
      // nntam - 16/04/2020: bổ sung thêm truyền vào loại button (typeButton)
      if (option.btnConfig != null) {
        btnConfigDefault.forEach((element) => {
          element.hasBtn = false;
          option.btnConfig.forEach((e) => {
            if (element.key === e.key) {
              element.target = e.target;
              element.hasBtn = true;
              element.text = e.text ? e.text : element.text;
              element.focus = e.focus;
              element.typeButton = e.typeButton ? e.typeButton : element.typeButton;
            }
          });
        });
      }

      // gán lại cấu hình mặc định với các tham số người dùng gửi vào
      var optionDefault = {
        title: option.title,
        message: option.message,
        messageDetail: option.messageDetail || null,
        icon:
          option.icon == false ? false : option.icon ? option.icon : "mi-exclamation-warning-48",
        line: option.line == false ? false : true,
        btnConfig: btnConfigDefault,
        closeMessageAfterLink: option.closeMessageAfterLink,
        close: option.close,
        width: option.width ? option.width : "444px",
        title: option.title ? option.title : null,
      };

      // Vue 3: dùng createApp + h() thay vì new Vue({ render: h => <JSX> })
      const mountEl = document.querySelector("#message-box");
      const app = createApp({
        render() {
          return h(MsMessageBox, { ref: "msgBox", option: optionDefault });
        },
        components: { MsMessageBox },
      });
      // Đăng ký global components (ms-button, ms-input, ...) cho app instance này
      registerComponents(app);
      const instance = app.mount(mountEl);

      // nhận sự kiện click vào button
      let msgBox = instance.$refs.msgBox;
      if (msgBox) {
        msgBox.$on("btnClick", function (msg, action) {
          resolve(action);
        });
        // hngiap - 26.05.2020: Bổ sung callback thêm tham số resolve, reject để
        // - Xử lý trường hợp await action của msgBox cần resolve để chạy tiếp
        msgBox.$on("linkActive", function () {
          me.customLinkActive(resolve, reject);
        });
        msgBox.$on("linkPopup", this.customLinkPopup);
      }
    });

    return promise;
  }

  customLinkActive(resolve, reject) {
    // console.log('run');
  }

  customLinkPopup() {}
  /**
   * Hàm hiện thị message box câu hỏi
   * @param option Nội dung thông báo hoặc config
   */
  showQuestion(option) {
    // cấu hình mặc định với msg Question
    var cf = {
      // icon: 'mi-exclamation-question-48',
      // line: true
    };
    if (typeof option === "object") {
      Object.assign(cf, option);
      if (!cf.title) cf.title = "Thông báo";
      if (option.yesNoCancel) {
        cf.btnConfig = [
          {
            key: "Cancel",
            target: "Left",
            text: "Hủy bỏ",
            typeButton: "secondary",
          },
          {
            key: "No",
            target: "Right",
            text: "Không",
            typeButton: "secondary",
          },
          {
            key: "Yes",
            target: "Right",
            text: "Có",
            focus: true,
            typeButton: option.typeButton || "danger",
          },
        ];
      } else {
        cf.btnConfig = cf.btnConfig
          ? cf.btnConfig
          : [
              {
                key: "No",
                target: "Right",
                text: "Không",
                typeButton: "secondary",
              },
              {
                key: "Yes",
                target: "Right",
                text: "Có",
                focus: true,
                typeButton: option.typeButton || "danger",
              },
            ];
      }
    } else {
      cf.message = option;
      cf.title = "Thông báo";
    }

    return this.show(cf);
  }

  /**
   * Hàm hiện thị message box câu hỏi
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   */
  showDelete(message, messageDetail, title) {
    // cấu hình mặc định với msg Question
    if (!title) {
      title = "Thông báo";
    }
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-question-48",
      line: true,
      btnConfig: [
        {
          key: "No",
          target: "Right",
          text: "Hủy bỏ",
          typeButton: "third",
        },
        {
          key: "Yes",
          target: "Right",
          text: "Xóa",
          typeButton: "danger-outline",
          focus: true,
        },
      ],
    };

    return this.show(option);
  }

  /**
   * Hàm hiện thị message box cảnh báo
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   */
  showWarning(message, messageDetail, title) {
    if (!title) {
      title = "Thông báo";
    }
    // cấu hình mặc định với msgWarning
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-warning-48",
      line: true,
      title: title,
      btnConfig: [
        {
          key: "Close",
          target: "Right",
          text: "Đóng",
          typeButton: "secondary",
          focus: true,
        },
      ],
    };
    return this.show(option);
  }

  /**
   * Hàm hiện thị message box lỗi
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   */
  showError(message, messageDetail, title, width = null) {
    if (!title) {
      title = "Thông báo";
    }
    // cấu hình mặc định với msg Error
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-error-48-2",
      line: true,
      title: title,
      width: width,
      btnConfig: [
        {
          key: "Close",
          target: "Right",
          text: "Đóng",
          typeButton: "danger",
          focus: true,
        },
      ],
    };
    return this.show(option);
  }

  /**
   * Hàm hiện thị message box thông tin
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   */
  showInfo(message, messageDetail, title) {
    // cấu hình mặc định với info
    if (!title) {
      title = "Thông báo";
    }
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-info-48",
      line: true,
      title: title,
      btnConfig: [
        {
          key: "Close",
          target: "Right",
          text: "Đóng",
          focus: true,
          typeButton: "secondary",
        },
      ],
    };
    return this.show(option);
  }

  /**
   * Hàm hiện thị message box xác nhận
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   */
  showConfirm(message, messageDetail, config, title) {
    // cấu hình mặc định với msg confirm
    if (!title) {
      title = "Thông báo";
    }
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-warning-48",
      title: title,
      line: true,
      btnConfig: config
        ? config
        : [
            {
              key: "Cancel",
              target: "Left",
              text: "Hủy bỏ",
            },
            {
              key: "No",
              target: "Right",
              text: "Không",
            },
            {
              key: "Yes",
              target: "Right",
              text: "Có",
              focus: true,
            },
          ],
    };
    return this.show(option);
  }

  /**
   * Hàm hiện thị message box thành công
   * @param {Message cần hiển thị ra} message
   * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
   * created by ntphong 19/3/2020
   */
  showSuccess(message, messageDetail, title) {
    // cấu hình mặc định với info
    if (!title) {
      title = "Thông báo";
    }
    var option = {
      message: message,
      messageDetail: messageDetail,
      icon: "mi-exclamation-success-48",
      line: true,
      title: title,
      btnConfig: [
        {
          key: "Close",
          target: "Right",
          text: "Đóng",
          typeButton: "primary",
          focus: true,
        },
      ],
    };
    return this.show(option);
  }
}

export default new MessageBox();
